module.exports = __webpack_public_path__ + "static/media/tri2.ac990e7a.svg";